import React, { memo, useEffect, useState } from 'react';
import { useAddUserGivenRatting } from '../../../Queries/QueryHooks/medwiki.hook';
import { isMobile } from 'react-device-detect';
import TooltipContainer from '../../../components/baseUiV3/components/TooltipContainer';

const MedwikiReviewStarRating = ({ user_given_rating, data }) => {
  console.log('USER GIVEN RATING', user_given_rating);
  // const [selectedRating, setSelectedRating] = useState(-1);
  const [rating, setRating] = useState(-1);
  const [hover, setHover] = useState(0);

  useEffect(() => {
    user_given_rating != 0 && setRating(user_given_rating);
  }, [user_given_rating]);

  const { mutate } = useAddUserGivenRatting(data?.type_id);

  const onRating = (rating) => {
    setRating(rating);
    // console.log(rating);
    mutate({
      type: data?.type_id,
      type_name: data?.type,
      rating: rating
    });
  };

  return (
    <div
      className="medwikiRatingBox d-flex flex-column flex-md-row align-items-center text-black rounded-3 p-3 p-md-4"
      id="medwiki_review_comments_user_rating"
    >
      {isMobile && (
        <span className="fs-16 fw-medium text-black">Rate this article &amp; write a review :</span>
      )}
      <div className="medwikiReviewStars d-flex align-items-center ms-0 ms-md-4">
        <div className="rating h-auto d-flex gap-3 mt-3 mt-sm-0">
          {[...Array(5)].map((star, index) => {
            index += 1;
            return (
              <button
                type="button"
                key={index}
                // className={index <= (hover || rating) ? "on" : "off"}
                onClick={() => onRating(index)}
                onMouseEnter={() => setHover(index)}
                onMouseLeave={() => setHover(rating)}
              >
                <TooltipContainer text={`Rate ${index} out of 5`} placement="top">
                  <span className="star">
                    <i
                      className={`${index <= (hover || rating) ? 'flaticon-star-1' : 'flaticon-star'
                        }  fs-1 transition text-primary`}
                      style={{ cursor: 'pointer' }}
                    ></i>
                  </span>
                </TooltipContainer>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default memo(MedwikiReviewStarRating);
